import type {App} from 'vue';
import type {Router} from 'vue-router';
import {initSentry} from './sentry';
import {initGtag} from './gtag';
import {createNotivue} from 'notivue';
import {installNavTelemetry} from '@/utils/navTelemetry';

export function setupPlugins(app: App, router: Router) {
    const notivue = createNotivue({
        position: 'top-center',
        limit: 4,
        enqueue: true,
        avoidDuplicates: true,
        notifications: {
            global: {duration: 2000}
        }
    });

    app.use(notivue);

    // Nav IA telemetry is intentional even offline (no-ops without gtag).
    installNavTelemetry(router);

    if (navigator.onLine) {
        initSentry(app);
        initGtag(router);
    } else {
        console.warn('Offline: Skipping Sentry and Google Analytics initialization.');
    }
}
